import { isTodayBeforeDate } from '@/utils/date';
import { useTranslate } from 'react-admin';
import Box from '@mui/material/Box';

interface Props {
    record: any;
    validatedUntilDate: any;
}

const CurrentNodeStatus = ({ record, validatedUntilDate }: Props) => {
    const translate = useTranslate();

    if (!validatedUntilDate) return <Box>---</Box>;

    return (
        <Box>
            {translate(
                isTodayBeforeDate(validatedUntilDate, 'YYYY/MM/DD') && record.isFirstInList
                    ? 'contract.node_state.in_progress'
                    : 'contract.node_state.pass',
            )}
        </Box>
    );
};

export default CurrentNodeStatus;
